<template>
    <!-- tickets -->
    <mu-paper class="rounded" :z-depth="5">
        <br>
        <h6 class="mx-2">{{ $t('module_itinerary.title_tickets') }}</h6>
        <br>
        <!-- departure -->
        <mu-container>
            <vs-table class="my-4" v-for="(item, key) of tickets.departure" :key="key" v-model="selectOption">
                <template #header>
                    <span>
                        {{ tickets.departure[key][0].origin_name }} - {{ tickets.departure[key][0].destination_name }}
                    </span>
                    <br>
                    <span class="float-lg-right">
                        {{ (tickets.departure[key][0].schedule_departure) ? tickets.departure[key][0].schedule_departure : $t('module_itinerary.datatable.header.open') }}
                    </span>
                </template>
                <template #thead>
                    <vs-tr>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.departure') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.status') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.seat') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.ticket_serie') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.ticket_number') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.rate') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.price') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.name') }}
                        </vs-th>
                    </vs-tr>
                </template>
                
                <template #tbody>
                    <vs-tr
                        v-for="(dep, indexDep) of tickets.departure[key]" 
                        :key="indexDep"
                        :is-selected="selectOption === dep && selectedActive"
                        :data="dep">
                        <vs-td>
                            <mu-icon color="primary" value="touch_app"></mu-icon>
                        </vs-td>
                        <vs-td>
                            <span>{{ seatView(dep.seat_status_id) }}</span>
                            <vs-tooltip right  v-if="![1, 2].includes(dep.seat_status_id)">
                                <mu-icon :size="14" value="contact_support"></mu-icon>
                                <template #tooltip>
                                    <div class="text-justify">
                                        <p>
                                            {{ $t('module_itinerary.status.text.txt1') }}<br> {{ $t('module_itinerary.status.text.txt2') }} <br> {{ $t('module_itinerary.status.text.txt3') }}
                                        </p>
                                    </div>
                                </template>
                            </vs-tooltip>
                        </vs-td>
                        <vs-td>
                            {{ dep.seat }}
                        </vs-td>
                        <vs-td>
                            {{ (dep.id) ? dep.id : '----' }}
                        </vs-td>
                        <vs-td>
                            {{ (dep.ticket_number) ? dep.ticket_number : '----' }}
                        </vs-td>
                        <vs-td>
                            {{ dep.rate_type }}
                        </vs-td>
                        <vs-td>
                            {{ dep.total }}
                        </vs-td>
                        <vs-td>
                            {{ `${dep.first_name} ${dep.last_name} ${dep.second_surname}` }}
                        </vs-td>
                    </vs-tr>
                </template>
                <template #footer v-if="showFooter">
                    <slot name="footer-departure"/>
                </template>
            </vs-table>
        </mu-container>
        <!-- /departure -->

        <mu-divider></mu-divider>

        <!-- return -->
        <mu-container v-if="itinerary.reservation">
            <vs-table class="my-4" v-for="(item, key) of tickets.return" :key="key" v-model="selectOption" v-if="itinerary.reservation.round">
                <template #header>
                    <span>
                        {{ tickets.return[key][0].origin_name }} - {{ tickets.return[key][0].destination_name }}
                    </span>
                    <br>
                    <span class="float-lg-right">
                        {{ (tickets.return[key][0].schedule_departure) ? tickets.return[key][0].schedule_departure : $t('module_itinerary.datatable.header.open') }}
                    </span>
                </template>
                <template #thead>
                    <vs-tr>
                       <vs-th>
                            {{ $t('module_itinerary.datatable.header.return') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.status') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.seat') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.ticket_serie') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.ticket_number') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.rate') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.price') }}
                        </vs-th>
                        <vs-th>
                            {{ $t('module_itinerary.datatable.header.name') }}
                        </vs-th>
                    </vs-tr>
                </template>
                
                <template #tbody>
                    <vs-tr
                        v-for="(ret, indexRet) of tickets.return[key]" 
                        :key="indexRet"
                        :is-selected="selectOption === ret && selectedActive"
                        :data="ret">
                        <vs-td>
                            <mu-icon color="primary" value="touch_app"></mu-icon>
                        </vs-td>
                        <vs-td>
                            <span>{{ seatView(ret.seat_status_id) }}</span>
                            <vs-tooltip right v-if="![1, 2].includes(ret.seat_status_id)">
                                <mu-icon :size="14" value="contact_support"></mu-icon>
                                <template #tooltip>
                                    <div class="text-justify">
                                        <p>
                                            {{ $t('module_itinerary.status.text.txt1') }}<br> {{ $t('module_itinerary.status.text.txt2') }} <br> {{ $t('module_itinerary.status.text.txt3') }}
                                        </p>
                                    </div>
                                </template>
                            </vs-tooltip>
                        </vs-td>
                        <vs-td>
                            {{ ret.seat }}
                        </vs-td>
                        <vs-td>
                            {{ (ret.id) ? ret.id : '----' }}
                        </vs-td>
                        <vs-td>
                            {{ (ret.ticket_number) ? ret.ticket_number : '----' }}
                        </vs-td>
                        <vs-td>
                            {{ ret.rate_type }}
                        </vs-td>
                        <vs-td>
                            {{ ret.total }}
                        </vs-td>
                        <vs-td>
                            {{ `${ret.first_name} ${ret.last_name} ${ret.second_surname}` }}
                        </vs-td>
                    </vs-tr>
                </template>
                <template #footer v-if="showFooter">
                    <slot name="footer-return"/>
                </template>
            </vs-table>
        </mu-container>
        <!-- /return -->
        
        <!-- alert schedules -->
        <alert-itinerary>
            <template #custom-content>
                <!-- select schedules -->
                <mu-col v-if="info.step === 0">
                    <mu-row class="my-2">
                        <mu-col class="px-2" :span="6">
                            <datepicker
                                v-model="info.date"
                                id="goingDatepicker"
                                :disabled-dates="info.dateDisable"
                                :bootstrap-styling="true"
                                format="dd-MM-yyyy"
                                :language="es"
                                @input="getSchedules(selectOption, $event)"/>
                        </mu-col>
                        <mu-col class="px-2" :span="6">
                            <v-select
                                class="align-middle"
                                v-model="info.schedules"
                                placeholder="Seleccionar hora"
                                :options="info.schedulesData"
                                :searchable="true"
                                :filterable="true"
                                :clearable="false">
                                <template #no-options="{ search, searching, loading }">
                                    {{ $t('selects.alert.error.schedules_not_found') }}
                                </template>
                            </v-select>
                        </mu-col>
                    </mu-row>

                    <vs-table>
                        <template #thead>
                            <vs-tr>
                                <vs-th>
                                    {{ $t('module_itinerary.datatable.header.status') }}
                                </vs-th>
                                <vs-th>
                                    {{ $t('module_itinerary.datatable.header.rate') }}
                                </vs-th>
                                <vs-th>
                                    {{ $t('module_itinerary.datatable.header.seat') }}
                                </vs-th>
                                <vs-th>
                                    {{ $t('module_itinerary.datatable.header.passenger') }}
                                </vs-th>
                            </vs-tr>
                        </template>
                        <template #tbody>
                            <vs-tr>
                                <vs-td>
                                    <span><b>{{ seatView(selectOption.seat_status_id) }}</b></span>
                                </vs-td>
                                <vs-td>
                                    {{ selectOption.rate_type }}
                                </vs-td>
                                <vs-td>
                                    {{ selectOption.seat }}
                                </vs-td>
                                <vs-td>
                                    {{ `${selectOption.first_name} ${selectOption.last_name} ${selectOption.second_surname}` }}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </mu-col>
                <!-- /select schedules -->

                <!-- template -->
                <mu-col v-else>
                    <layout
                        :seats_template="info.seatsTemplate"
                        :title="$t('module_itinerary.title_bus')"
                        :subtitle="`DE ${selectOption.origin_name} <br> A ${selectOption.destination_name}`"
                        :passengers="1" 
                        :origin="selectOption.destination_id"
                        :destination="selectOption.origin_id"/>
                </mu-col>
                <!-- /template -->

            </template>

            <template #custom-actions>
                <vs-row justify="center">
                    <vs-col class="px-2" sm="6" md="6" lg="6">
                        <vs-button color="danger" relief @click="cleanData()">
                            <mu-icon value="close"></mu-icon> {{ $t('button_action.close') }}
                        </vs-button>
                    </vs-col>
                    <vs-col class="px-2" sm="6" md="6" lg="6">
                        <vs-button color="#009fe3" relief @click="(info.step === 1) ? $emit('change-schedule', info.schedules) : getAvaibility()">
                            <mu-icon :value="(info.step === 0) ? 'arrow_right_alt' : 'update'"></mu-icon>{{ (info.step === 0) ? $t('module_itinerary.button_action.next') : $t('module_itinerary.button_action.update') }}
                        </vs-button>
                    </vs-col>
                </vs-row>
            </template>
        </alert-itinerary>
        <!-- /alert schedules -->
    </mu-paper>
    <!-- /tickets -->
</template>

<script>
    // COMPONENTS
    import Datepicker from 'vuejs-datepicker'
    import {en, es} from 'vuejs-datepicker/dist/locale'
    import Layout from '@/components/Layout/layout_intinerary'
    import AlertItinerary from '@/components/Modal/AlertItinerary'
    // HELPERS
    import _ReservationHelper from '@/store/helpers/reservation/reservation'
    import _GlobalHelper from '@/store/helpers/global'
    // VUEX
    import { mapActions, mapGetters, mapMutations } from 'vuex'

    export default {
        name: 'tickets',
        props: {
            selectedActive: {
                type: Boolean,
                default: false
            },
            showFooter: {
                type: Boolean,
                default: false
            },
            event: {
                type: String,
                default: null
            }
            
        },
        components: {
            Datepicker: Datepicker,
            Layout: Layout,
            AlertItinerary: AlertItinerary
        },
        data: () => ({
            tickets: {
                departure: {},
                return: {}
            },
            selectOption: null,
            
            // change this part
            info: {
                date: null,
                schedules: null,
                dateDisable: {
                    to: new Date(),
                    from: null
                },
                schedulesData: [],
                step: 0,
                seatsTemplate: {}
            },
            // languages
            es: es,
            en: en
        }),
        computed: {
            ...mapGetters({
                itinerary: _ReservationHelper.getters.itineraryData
            }),

            loading: {
                set (data) {
                    this.set_loading(data)
                },
                get () {

                }
            }
        },
        watch: {
            selectOption(data) {
                if (data && this.selectedActive) {
                   this.getOptions(data)
                }
            } 
        },
        methods: {
            ...mapActions({
                itinerarySchedules: _ReservationHelper.actions.itinerarySchedules,
                avaibility: _ReservationHelper.actions.itineraryAvaibility
            }),
            ...mapMutations({
                set_alert_simple: _GlobalHelper.mutations.setAlertSimple,
                set_loading: _GlobalHelper.mutations.loading,
                set_alert_itinerary: _GlobalHelper.mutations.setAlertItinerary
            }),
            
            // get options
            getOptions(data) {
                if (this.event) {
                    // change schedule
                    if (this.event === 'change-schedule') {
                        this.info.date = (this.info.date) ? this.info.date : new Date(this.$datetime.now())
                        this.getSchedules(data, this.info.date)
                    }
                }
                
            },

            // clean data
            cleanData() {
                Object.assign(this.$data.info, this.$options.data.call(this).info)
                this.set_alert_itinerary({ show: false })
                this.selectOption = null
            },

            // get avaibility
            async getAvaibility() {
                const message = []
                this.loading = {
                    show: true,
                    message: `<h5>${this.$i18n.t(`loading.search_avaiability`)}...</h5>`
                }
                this.set_alert_itinerary({ show: false })
                const { schedule_id, schedule_detail_id, ticket_id  } = this.info.schedules

                const { success, data, error } = await this.avaibility({ id: this.itinerary.reservation.id, schedule_id: schedule_id, schedule_detail_id: schedule_detail_id, ticket_id: ticket_id }).catch(error => console.log(error)).finally(() => this.loading = { show: false, message: null })

                // api failed or disconnected
                if (!success && error === undefined) {
                    this.set_alert_simple({
                        show: true,
                        title: 'api.title_error',
                        message: message
                    })
                    return
                }
                // errors api
                if (!success && error.length >= 0) {
                    if (message.length === 0) {
                        message.push('api.commons.alert.error.default_error')
                    }
                    this.set_alert_simple({
                        show: true,
                        title: 'api.title_error',
                        message: message
                    })
                    return
                }
                // get data
                if (success && data) {
                    this.set_alert_itinerary({ show: true })
                    this.info.step = 1
                    this.info.seatsTemplate = data.template
                    return
                }

            },

            setDatePickersToToday() {
                const date = new Date()

                this.info.dateDisable.to.setDate(date.getDate() - 1)
                const month = (date.getDate() === 1) ? date.getMonth() - 1 : date.getMonth()

                this.info.dateDisable.to.setMonth(month)
                this.info.dateDisable.to.setFullYear(date.getFullYear())
                this.info.dateDisable.from = null
            },

            // return seat status
            seatView(status) {
                if (status === 1) {
                    return  this.$i18n.t('module_itinerary.seat_status.ok')
                } 
                else if (status === 2) {
                    return this.$i18n.t('module_itinerary.seat_status.etck')
                } 
                else if (status === 3) {
                    return this.$i18n.t('module_itinerary.seat_status.pend')
                } 
                else if (status === 4) {
                    return this.$i18n.t('module_itinerary.seat_status.cancel')
                }
                else if (status === 5) {
                    return this.$i18n.t('module_itinerary.seat_status.aboard')
                }
            },

            // get tickets
            getTickets() {
                // there's information
                if (Object.keys(this.itinerary).length > 0) {
                    // tickets departure
                    const ticketsDeparture = []
                    Object.keys(this.itinerary.tickets.departure).map(key => {
                        // set tickets departure 23_1_7
                        ticketsDeparture[key] = this.itinerary.tickets.departure[key]
                    })
                    for (const key in ticketsDeparture) {
                        for (const [index, dep] of ticketsDeparture[key].entries()) {
                            // set tickets
                            this.setInformationTicket('departure', key, dep)
                        }
                    }

                    // tickets return
                    if (this.itinerary.tickets.return && this.itinerary.reservation.round) {
                        const ticketsReturn = []
                        Object.keys(this.itinerary.tickets.return).map(key => {
                            // set tickets return 23_1_7
                            ticketsReturn[key] = this.itinerary.tickets.return[key]
                        })
                        for (const key in ticketsReturn) {
                            for (const [index, ret] of ticketsReturn[key].entries()) {
                                // set tickets
                                this.setInformationTicket('return', key, ret)
                            }
                        }
                    }
                }
            },

            // set information
            setInformationTicket(type = 'departure', key, data) {
                if (!this.tickets[type][key]) {
                    this.tickets[type][key] = []
                }
                if (Array.isArray(this.tickets[type][key])) {
                    this.tickets[type][key].push({
                        id: data.id,
                        schedule_id: data.schedule_id,
                        schedule_detail_id: data.schedule_detail_id,
                        first_name: data.first_name,
                        last_name: data.last_name,
                        second_surname: data.second_surname,
                        rate_type: data.rate_type,
                        rate_type_id: data.rate_type_id,
                        seat: data.seat,
                        seat_id: data.seat_id,
                        seat_status_id: data.seat_status_id,
                        ticket_number: data.ticket_number,
                        ticket_serie: data.ticket_serie,
                        schedule_departure: data.schedule_departure,
                        origin_id: data.origin_id,
                        origin_name: data.origin_name,
                        destination_id: data.destination_id,
                        destination_name: data.destination_name,
                        begin_validity: data.begin_validity,
                        end_validity: data.end_validity,
                        total: this.$fixed(data.total)
                    })
                }
            },

            // get schedules 
            async getSchedules(val, date) {
                if ([1, 2].includes(val.seat_status_id)) {
                    const message = []
                    this.loading = {
                        show: true,
                        message: `<h5>${this.$i18n.t(`loading.search_schedule`)}...</h5>`
                    }
                    this.set_alert_itinerary({ show: false })

                    let beginValidity = null
                    let endValidity = null

                    const beginParts = (val.begin_validity) ? val.begin_validity.split('/') : []
                    const endParts = (val.end_validity) ? val.end_validity.split('/') : []

                    // change date format
                    for (const i in beginParts.reverse()) {
                        // begin validity
                        beginValidity = (Number(i) === 0) ? new Date().getFullYear().toString() : `${beginValidity}-${beginParts[i]}`
                    }
    
                    for (const i in endParts.reverse()) {
                        // end validity
                        endValidity = (Number(i) === 0) ? `${new Date().getFullYear() + 1}` : `${endValidity}-${endParts[i]}`
                    }


                    if (this.$datetime.differenceInDays(new Date(date), new Date(beginValidity), false) < 0 && this.$datetime.differenceInDays(new Date(endValidity), new Date(date), false) < 0) {
                        message.push('module_itinerary.aler.errors.expiration')
                    }
                   
                    date = this.$datetime.dateFormater(date, 'yyyy-mm-dd')
                    
                    const { success, data, error } = await this.itinerarySchedules({ id: this.itinerary.reservation.id, ticket_id: val.id, date: date }).catch(error => console.log(error)).finally(() => this.loading = { show: false, message: null })

                    // api failed or disconnected
                    if (!success && error === undefined) {
                        this.set_alert_simple({
                            show: true,
                            title: 'api.title_error',
                            message: message
                        })
                        return
                    }
                    // errors api
                    if (!success && error.length >= 0) {
                        if (message.length === 0) {
                            message.push('api.commons.alert.error.default_error')
                        }
                        this.set_alert_simple({
                            show: true,
                            title: 'api.title_error',
                            message: message
                        })
                        return
                    }
                    // get data
                    if (success && data) {
                        this.set_alert_itinerary({ show: true })

                        // set schedules
                        if (Array.isArray(data.schedules)) {
                            // all schedules
                            const scheduleDeparture = (val.schedule_departure) ? val.schedule_departure.split(' ')[3] : this.$datetime.dateFormater(date, 'hh:MM')
                            this.info.schedulesData = []

                            for (const item of data.schedules) {
                                if (scheduleDeparture !== this.$datetime.dateFormater(item.departure, 'hh:MM')) {
                                    this.info.schedulesData.push({
                                        schedule_id: item.schedule,
                                        schedule_detail_id: item.schedule_detail,
                                        ticket_id: val.id,
                                        label: this.$datetime.dateFormater(item.departure, 'hh:MM TT')
                                    })
                                }
                            }
                            
                            this.$forceUpdate()
                            // set first data
                            this.info.schedules = this.info.schedulesData[0]
                        }
                    
                        return
                    }
                }
            }
        },
        created() {
            this.setDatePickersToToday()
            this.getTickets()
        } 
    }
</script>
<style lang="scss">
    .vs-table__header {
        background: none;
    }

</style>